/**
 * La cabecera con la que las peticiones de la DESCARGA COMPLETA se distinguen de las
 * de la app (ver `redOffline`: no se cuentan como «el usuario está cargando algo» y se
 * quita antes de salir a la red). Módulo sin dependencias a propósito: lo importan
 * piezas que pinta cualquier pantalla (fotos, avatares) y no deben arrastrar el cliente
 * de Supabase.
 */
export const CABECERA_ESPEJO = "x-ulture-espejo";
